import * as React from "react";
import "./index.css";

const Menu = ({
  children,
  setIsOpen,
  onOverlayClick,
  title,
  className,
}) => {
  React.useEffect(() => {
    const handleEsc = (e) => {
      console.log("exit");
      if (e.keyCode === 27) {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  return (
    <>

      <section
        className={`popup-overlay requires-no-scroll`}
        title={"Overlay"}
        onClick={(e) => {
          if (Array.from(e.target.classList).includes("popup-overlay")) {
            setIsOpen(false);
          }
        }}
      >
        <div
          className={`popup roll-out ${className}`}
          title={title || "Menu"}
        >
          {children}
        </div>
      </section>
    </>
  );
};

export default Menu;
